import { useTransitionStore } from '../store/transitionSlice';

const FADE_DURATION_MS = 400;

let inProgress = false;

const sleep = (ms: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, ms));

/**
 * Fade-out to black (400 ms), run `action`, fade back from black (400 ms).
 * If a transition is already running, the new call is dropped silently —
 * no queue, no chaining. The caller is responsible for handling its own
 * state during the action.
 *
 * `action` may be sync or async. The fade-out only starts after `action`
 * (and its returned promise, if any) resolves, so use this to wrap a
 * gameplay state switch + any post-switch setup that must happen under
 * cover of the black overlay.
 */
export async function fadeTransition(
  action: () => void | Promise<void>,
): Promise<void> {
  if (inProgress) {
    return;
  }
  inProgress = true;
  const { setActive } = useTransitionStore.getState();
  setActive(true);
  await sleep(FADE_DURATION_MS);
  try {
    await action();
  } finally {
    setActive(false);
    await sleep(FADE_DURATION_MS);
    inProgress = false;
  }
}
